import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './MessagesList.styles';

import Modal from 'react-awesome-modal';
import { IoMdClose } from 'react-icons/io';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListMessages extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToView = this.goToView.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.emailModalToggle = this.emailModalToggle.bind(this);
        this.emailSubmit = this.emailSubmit.bind(this);
    } 

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    } 

    public emailModalToggle() {
        const data = this.state.data;

        data.emailModal = !data.emailModal;

        this.setState({data});
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToView(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'institutions/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async emailSubmit(e) {
        e.preventDefault();

        const data = this.state.data; 

        data.uploading = true;

        this.setState({data});

        const fileInputElement = e.target.elements.upld;
        const formData = new FormData();

        formData.append('template_id', e.target.elements.template.value);

        for (const row of fileInputElement.files) {
            formData.append('files', row);
        }

        const res = await this.props.services.adminAPI.uploadEmails(formData)
        
        if (res.ok) {

            const data = this.state.data;

            data.uploading = false;

            data.emailModal = false;
                
            this.setState({data});

            toast.success("Success");
        }

        else{

            toast.error("Failed to complete upload");
            
            data.uploading = false;
                
            this.setState({data});
        }

        
    
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <div style={{margin: '3px', backgroundColor: 'grey'}}>yyytytyt{props.BodyHtml}</div>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;


        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const messagesDataKey = ["id", "Subject", "BodyHtml", "Created"];
        
        const messagesThead = ["ID", "Subject", "BodyHtml", "Created"];

        const messagesRes = await adminAPI.getSystemMessages();

        const templatesRes = await adminAPI.getTemplates();

        if (messagesRes.ok) {
            
            const messages = messagesRes.data.messages;

            const templates = templatesRes.data.templates;

            this.setState(
                {
                     data: {
                        messages,
                        loaded: true,
                        messagesDataKey,
                        messagesThead,
                        emailModal: false,
                        templates
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public TemplateOPtions (options) {

        return(
            options.map(
                (d, i) =>
                <option key={d.id} value={d.id}>
                    {d.Name}
                </option>
                )
        )
        
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
              <Button onClick={this.emailModalToggle}>Bulk Email</Button>
                <SortableTbl
                    tblData={data.messages}
                    tHead={data.messagesThead}
                    dKey={data.messagesDataKey}
                    defaultCSS={false}
                />

              </Content>

              <Modal
                visible={this.state.data.emailModal}
                effect="fadeInUp"
                styles={{ backgroundColor: "transparent" }}
                container={{ background: "#ff0033" }}
                onClickAway={this.emailModalToggle}
              >
                <div className='join-form-wrapper'>
                  <div className="join-form-header">
                    <p>Email A List</p>
                    <IoMdClose
                      size="32px"
                      onClick={this.emailModalToggle}
                      className="join-form-close"
                    />
                  </div>

                  <form onSubmit={this.emailSubmit}>
                    
                    <input id="upld" type="file" name="upld" accept=".csv" multiple={false} required={true} style={{padding: '5px', width: '100%', marginBottom: '5px'}}/>
    
                    <select
                      name="template"
                      data-arg="template"
                      id="template"
                      required={true}
                      className="custom-select"
                    >
                      <option value="" selected={true}>
                        {" "}
                        Choose a Template{" "}
                      </option>

                      

                      {this.TemplateOPtions(data.templates)}
            
                    </select>
                    
                    <Loader color="#3EE9F7" loaded={!this.state.data.uploading}>                      
                        <button
                          className='green-button join-button'
                          type="submit"
                          style={{ margin: "7px" }}
                        >
                          Submit
                        </button>                 
                    </Loader>
                  </form>
                </div>
                
            </Modal>
              
              </Wrapper>
        );

    }

}

export default withServices(ListMessages);


// WEBPACK FOOTER //
// ./src/pages/Admin/Messages/MessagesList/MessagesList.tsx